import React, { useState } from 'react';
import axios from './axiosConfig';

const ForgotPassword: React.FC = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            const response = await axios.post('/api/recover-password', { email });
            if (response.status === 200) {
                setMessage('Please check your email to reset your password.');
            } else {
                // 这个分支实际上可能不会被执行，因为 axios 在非 2xx 响应时抛出异常
                setMessage('Email not found.');
            }
        } catch (error) {
            // @ts-ignore
            if (error.response && error.response.status === 404) {
                // 当服务器返回404状态码时特别处理
                setMessage('Email not found.');
            } else {
                // 其他所有错误
                setMessage('Failed to send reset email. Please try again later.');
            }
        }
    };


    return (
        <div>
            <form onSubmit={handleSubmit}>
                <label>Email:</label>
                <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <button type="submit">Send Reset Email</button>
            </form>
            {message && <p>{message}</p>}
        </div>
    );
};

export default ForgotPassword;
